var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"chats-btn",class:[_vm.size ? 'chats-btn--' + _vm.size : '', _vm.isOpen ? 'rotate' : ''],style:([!_vm.isOpen ?
    {
      'background-image': `url(${_vm.mainIcon.icon})`,
      'background-color': _vm.mainIcon.background
    } :
    {
      'background-image': `url(${_vm.mainIcon.closeIcon})`,
      'background-color': _vm.mainIcon.closeBackground
    }
  ]),attrs:{"type":"button","aria-label":"chats-button"},on:{"click":_vm.toggleBtn}})
}
var staticRenderFns = []

export { render, staticRenderFns }